import { render, staticRenderFns } from "./PastDiscussion.vue?vue&type=template&id=0c17d30a&scoped=true"
import script from "./PastDiscussion.vue?vue&type=script&lang=ts"
export * from "./PastDiscussion.vue?vue&type=script&lang=ts"
import style0 from "./PastDiscussion.vue?vue&type=style&index=0&id=0c17d30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17d30a",
  null
  
)

export default component.exports